// 微信小程序 WebView 判断
export const isWeChatMiniProgram = () =>
    (typeof window !== 'undefined' && window.__wxjs_environment === 'miniprogram') ||
    (window.navigator.userAgent || '').toLowerCase().includes('miniprogram') ||
    (!!window.wx && !!window.wx.miniProgram)

// 字节跳动小程序 WebView 判断（抖音/头条等）
export const isByteDanceMiniProgram = () =>
    (typeof window !== 'undefined' && !!window.tt && !!window.tt.miniProgram) ||
    /toutiaomicroapp|bytedancemicroapp|microapp/i.test(window.navigator.userAgent || '')

// 是否为小程序环境
export const isMiniProgram = () => isWeChatMiniProgram() || isByteDanceMiniProgram()

// 是否为手机、平板设备
export function isMobileOrTablet() {
    // 获取用户代理字符串
    const userAgent = navigator.userAgent || window.opera
    // 尝试创建 TouchEvent
    const canCreateTouchEvent = () => {
        try {
            document.createEvent('TouchEvent')
            return true
        } catch (e) {
            return false
        }
    }
    // 注意：这些字符串可能需要根据新的设备或浏览器更新进行调整
    // 注意：勿将 micromessenger / mini 等浏览器特征当作移动端标识
    // （PC 微信 UA 含 MicroMessenger、MiniProgramEnv，会误判；小程序由 isMiniProgram 单独处理）
    const mobileAndTabletRegex =
        /android|webos|iphone|ipad|ipod|blackberry|bb10|IEMobile|opera\smini|mobile|mobile\s+?safari|mobile\s+?explorer|windows\s+?phone|fennec|firefox\s+?mobile|silk\/|dolfin|mobile\s+?safari|chrome\/.*mobile|maxthon|mqqbrowser|ucbrowser|baidubrowser|qqbrowser|2g\s+?iphone|google\s+?wireless\s+?transceiver|nokia|sony|ericsson|mot|samsung|lge|nec|toshiba|panasonic|philips|sharp|portalmmm|blazer|avantgo|danger|palm|series60|p800|p900|treo|up\.browser|up\.link|windows\s+?ce|iemobile|pocket|midp|wap|phone|smartphone|cldc|netfront|opera\s+?mobi|windows\s+?phone\s+?os|symbian|maemo|mobileexplorer|palmos|psp|pocketpc|incognito|fennec|ipaq|webos|go\.web|overstock|palmsource|plucker|xiino|vodafone|portalmmm|vodafone\/|windows\s+?ce;|xda/i

    // 匹配并返回结果
    return mobileAndTabletRegex.test(userAgent) || canCreateTouchEvent() || isMiniProgram()
}

export function getCookie(name) {
    const cookieArray = document.cookie.split('; ')
    let cookieValue = null

    for (let i = 0; i < cookieArray.length; i++) {
        const cookie = cookieArray[i]
        if (cookie.startsWith(name + '=')) {
            cookieValue = decodeURIComponent(cookie.substring(name.length + 1))
            break
        }
    }
    return cookieValue
}

export function TMapLoader(key) {
    return new Promise(function (resolve, reject) {
        window.init = function () {
            // eslint-disable-next-line no-undef
            resolve(TMap)
        }
        const script = document.createElement('script')
        script.type = 'text/javascript'
        script.src = `https://map.qq.com/api/gljs?v=1.exp&callback=init&key=${key}&libraries=view,geometry,visualization,model,tools,service`
        script.onerror = reject
        document.body.appendChild(script)
    })
}

// 默认渲染数据处理
export function handleDefaultValue(res) {
    const data = {}
    for (const item of res) {
        if (item.surfaceType === 'PUBLICFACILITIES') continue
        data[item.surfaceType] = item
    }
    return data
}

export function getImageUrl(name) {
    return new URL(`../assets/home/${name}.png`,
        import.meta.url).href
}

// 动态加载模块
export const loadRemModule = async () => {
    try {
        if (!isMobileOrTablet()) return
        await import('../plugins/rem.js')
    } catch (error) {
        console.error('Failed to load rem module:', error)
    }
}

// 获取 OSS 地址
export const getOSSUrl = path => {
    return `https://shanghai-house-model.hfwgsj.com/${path}`
}

/**
 * 获取 URL 中的参数
 * @param {string} [paramName] - 可选，指定要获取的参数名，不填则返回所有参数对象
 * @param {string} [url] - 可选，指定 URL 字符串，不填则默认取当前页面 URL
 * @returns {string|object|null} - 返回指定参数值（字符串）、所有参数（对象）或 null（无参数时）
 */
export function getUrlParam(paramName, url) {
    // 默认为当前页面 URL
    const targetUrl = url || window.location.href;

    // 提取 URL 中的查询字符串（? 后面的部分）
    const queryString = targetUrl.split('?')[1];
    if (!queryString) return paramName ? null : {}; // 无参数时返回空对象或 null

    // 将查询字符串分割为参数数组（处理 & 连接的参数）
    const paramsArray = queryString.split('&');
    const params = {};

    // 解析每个参数的键值对
    paramsArray.forEach(item => {
        // 分割键和值（处理 = 可能在值中出现的情况，只分割第一个 =）
        const [key, ...valueParts] = item.split('=');
        if (key) {
            // 解码参数（处理中文、特殊字符等）
            const decodedKey = decodeURIComponent(key);
            const decodedValue = valueParts.length > 0 ?
                decodeURIComponent(valueParts.join('=')) :
                ''; // 处理无值的参数（如 ?name&age=18 中的 name）
            params[decodedKey] = decodedValue;
        }
    });

    // 返回指定参数或所有参数
    return paramName ? (params[paramName] || null) : params;
}